import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Typography } from '../typography';
import { Button } from '../button';
import { InputContainer } from '../input';
import { RadioLabel } from '../radio';
import { ModalBase, ModalWrapper, ModalFooterButtons, ModalBodyInputs } from './ModalComponents';
import { useStateDebounce } from '../../hooks';
import { containerTypes } from '../../const';
import { i18n } from '../../i18n';
import { SearchableSelect } from '../select';
import { clientYardService } from '../../services';
import { extendContainerValidator } from '../../utils';

const Radios = styled(ModalBodyInputs)`
  grid-template-columns: repeat(5, max-content);
  grid-auto-flow: column;
`;

export const containerListModal: any = {};

export const ContainerListModal = ({ validContainers }: { validContainers?: boolean }) => {
  const [open, setOpen] = useState(false);
  const [containerNumber, setContainerNumber] = useState<any>([]);
  const [containerType, setContainerType] = useState<any>([]);
  const [containers, setContainers, isLoading] = useStateDebounce('', 1000, true);

  const [clientName, setClientName] = useState('');

  useEffect(() => {
    const newContainerNumber: any = [];
    const lines = containers.split('\n');
    lines.forEach((line: any) => {
      line = line.trim();

      if (!line) return;

      newContainerNumber.push(line);
    });

    if (!newContainerNumber.length) {
      newContainerNumber.push('');
    }
    setContainerNumber(newContainerNumber);
  }, [containers]);

  useEffect(() => {
    containerListModal.open = () => {
      setContainerNumber([]);
      setContainerType('');
      setContainers('', true);
      setClientName('');

      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    Object.keys(containerListModal).forEach((key) => {
      if (key !== 'open') delete containerListModal[key];
    });

    setOpen(false);
  };

  const handleOnChange = (e: any) => {
    setContainers(e.target.value);
  };

  const handleContainerTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setContainerType(e.target.value);
  };

  const handleSubmitClick = async () => {
    let filteredContainerNumber = containerNumber.filter((number: string) => number.length);

    if (validContainers) {
      filteredContainerNumber = filteredContainerNumber.filter(
        (number: string) => number.length === 11 && extendContainerValidator(number),
      );
    }

    containerListModal?.fc({
      containerNumber: filteredContainerNumber,
      containerType: new Array(filteredContainerNumber.length).fill(containerType),
      containerCondition: new Array(filteredContainerNumber.length).fill(''),
      containerContent: new Array(filteredContainerNumber.length).fill(false),
    });
    handleOnClose();
  };

  return (
    <ModalBase
      id={'container-list-modal'}
      open={open}
      onClose={handleOnClose}
      paperSize={containerListModal.isFilterList ? undefined : 'max-content'}
    >
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('button.containerList')}
        </Typography>
        {!containerListModal.isFilterList && (
          <Radios>
            {[{ label: i18n.t('dropdown.mixed'), value: '' }, ...containerTypes].map((type) => (
              <RadioLabel
                key={type.value}
                checked={containerType === type.value}
                onChange={handleContainerTypeChange}
                value={type.value}
                name={'container-types'}
                label={type.label}
              />
            ))}
          </Radios>
        )}
        {containerListModal.isFilterList && containerListModal.yardId && (
          <SearchableSelect
            selectedOptionLabel={clientName}
            label={i18n.t('label.client')}
            onSelect={(obj: any) => {
              if (obj && obj.id) {
                containerListModal.clientCode = obj.label;
                setClientName(obj.label);
              } else {
                containerListModal.clientCode = '';
                setClientName('');
              }
            }}
            queryFn={() => {
              return clientYardService.assignedClients({
                id: containerListModal.yardId,
              });
            }}
            queryKey={['clients', 'assigned-clients' + containerListModal.yardId]}
            selectedAreasEqaul={{ key: 'id', keys: [containerListModal.clientId] }}
            withClearButton
          />
        )}
        <InputContainer
          className="container-list-input-area"
          label={i18n.t('label.containerNumbers')}
          placeholder={'AAAZ1234567\nAAAZ1234567\nAAAZ1234567\nAAAZ1234567'}
          data-size={'medium'}
          rows={4}
          multiline
          defaultValue={containers}
          onChange={handleOnChange}
        />
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button
            size={'medium'}
            data-color={'primary'}
            onClick={handleSubmitClick}
            disabled={
              isLoading ||
              (containerListModal.isFilterList &&
                !containerListModal.clientCode &&
                containerListModal.yardId)
            }
          >
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
